import { Heading, Modal, ModalBody, ModalHeader } from 'bold-ui'
import { CriteriosVulnerabilidadeFamiliar } from 'graphql/types.generated'

import { CriteriosVulnerabilidadeFamiliarPanel } from './CriteriosVulnerabilidadeFamiliarPanel'

interface CriteriosVulnerabilidadeFamiliarModalProps {
  open: boolean
  onClose: () => void
  criterios: CriteriosVulnerabilidadeFamiliar
}

export function CriteriosVulnerabilidadeFamiliarModal(props: Readonly<CriteriosVulnerabilidadeFamiliarModalProps>) {
  const { open, onClose, criterios } = props

  return (
    <Modal open={open} onClose={onClose} size='large'>
      <ModalHeader>
        <Heading level={1}>Critérios de vulnerabilidade familiar presentes</Heading>
      </ModalHeader>
      <ModalBody>
        <CriteriosVulnerabilidadeFamiliarPanel criterios={criterios} />
      </ModalBody>
    </Modal>
  )
}
